<template>
	<v-form
		><v-container>
			<v-row
				><v-col> <h1>Add new Flight</h1></v-col> </v-row
			><v-row
				><v-col>
					<v-alert
						type="error"
						:text="error"
						v-model="error"
					></v-alert> </v-col></v-row
			><v-row>
				<v-col>
					<AirplaneInput
						@returnValue="setAirplane"
						label="Airplane"
					></AirplaneInput>
				</v-col>

				<v-col>
					<Datepicker v-model="date" :enable-time-picker="false"></Datepicker>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<AirportInput @returnValue="setDeparture" label="Departure Airport" />
				</v-col>
				<v-col>
					<Datepicker v-model="departure_time" time-picker></Datepicker>
				</v-col> </v-row
			><v-row>
				<v-col>
					<AirportInput @returnValue="setArrival" label="Arrival Airport" />
				</v-col>
				<v-col>
					<Datepicker v-model="arrival_time" time-picker></Datepicker>
				</v-col> </v-row
			><v-row>
				<v-col>
					<v-text-field
						v-model="takeoffs"
						label="Takeoffs"
						required
					></v-text-field>
				</v-col>

				<v-col>
					<v-text-field
						v-model="landings"
						label="Landings"
						required
					></v-text-field>
				</v-col>
				<v-col>
					<v-switch v-model="pic" color="primary" label="PIC"></v-switch>
				</v-col>
				<v-col> </v-col>
			</v-row>
			<v-row>
				<v-col><v-text-field label="Remarks"></v-text-field></v-col
			></v-row>
			<v-row
				><v-col>
					<v-btn @click="submit()">Save</v-btn>
					<v-btn @click="this.$emit('closeOverlay')">Close</v-btn>
				</v-col>
			</v-row></v-container
		></v-form
	>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import AirportInput from "@/components/AirportInput";
import AirplaneInput from "./AirplaneInput.vue";

import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
	data: () => ({
		airplane: null,
		date: null,
		departure_airport: null,
		departure_time: null,
		arrival_airport: null,
		arrival_time: null,
		landings: null,
		takeoffs: null,
		pic: false,
		error: null,
	}),
	components: {
		AirportInput,
		AirplaneInput,
		Datepicker,
	},
	computed: {
		...mapState({
			token: "token",
		}),
	},
	methods: {
		submit() {
			try {
				this.checkForm();
				axios.post(
					process.env.VUE_APP_BACKEND_URL + "/flight/",
					{
						plane: this.airplane.value,
						date: this.date,
						departure_airport: this.departure_airport,
						departure_time: this.departure_time,
						arrival_airport: this.arrival_airport,
						arrival_time: this.arrival_time,
						landings: this.landings,
						takeoffs: this.takeoffs,
						pic: this.pic,
					},
					{
						headers: {
							Authorization: "bearer " + this.token,
						},
					}
				);
				this.$emit("updateTable");
				this.$emit("closeOverlay");
			} catch (e) {
				this.error = e.message;
				console.log(e.message);
			}
		},
		checkForm() {
			if (
				this.airplane &&
				this.date &&
				this.departure_airport &&
				this.departure_time &&
				this.arrival_airport &&
				this.arrival_time &&
				this.landings &&
				this.takeoffs
			) {
				if (isNaN(this.landings) || isNaN(this.takeoffs)) {
					throw new Error("Landings / Takeoffs must be a number");
				}
			} else {
				throw new Error("All fields must be filled!");
			}
		},
		setDeparture(val) {
			this.departure_airport = val;
			console.log("Depature set to: " + this.departure_airport);
		},
		setArrival(val) {
			this.arrival_airport = val;
			console.log("Arrival set to: " + this.arrival_airport);
		},
		setAirplane(val) {
			this.airplane = val;
		},
		reset() {
			this.plane = "";
			this.date = "";
			this.departure_airport = "";
			this.departure_time = "";
			this.arrival_airport = "";
			this.arrival_time = "";
			this.landings = 0;
			this.takeoffs = 0;
			this.pic = false;
		},
	},
};
</script>

<style></style>
